import React from 'react';
import PropTypes from 'prop-types';
import { Data } from '@nike/nike-design-system-icons';

import Icon from '~COMPONENTS/icon/Icon';
import P from '~COMPONENTS/containers/Paragraph';
import { H1, H3 } from '~COMPONENTS/containers/Headers';
import Button from '~COMPONENTS/button/Button';
import SpacerDot from '~COMPONENTS/SpacerDot';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const OrderDetailsHeader = ({
  orderNumber,
  orderStatus,
  productCount,
  downloadHander,
  downloadReportHandler,
  printHandler,
  showDownloadReportButton
}) => (
  <div className='orderDetails__header_updateWrapper d-sm-iflx'>
    <div>
      {orderNumber && (
        <H1 className='mb1-sm'>
          <TranslatedCopy id='global.order' /> {orderNumber}
        </H1>
      )}
      <H3>
        <TranslatedCopy id='global.items.value' values={{ amount: productCount }} />
        <span className='d-sm-ib d-md-h'>
          <SpacerDot />
          {orderStatus}
        </span>
      </H3>
    </div>
    <div className='d-sm-h d-md-b'>
      <P className='body-3 mb0-sm u-capitalize'>{orderStatus.toLowerCase()}</P>
      <Button
        className='p0-sm mr4-sm bg-white'
        onClick={downloadHander}
        aria-label={new TranslatedCopy({ id: 'orderreturns.report.download' }).toString()}
        data-desc='download__button'
      >
        <Icon name='download' alt={new TranslatedCopy({ id: 'orderreturns.report.download' }).toString()} />
      </Button>
      {showDownloadReportButton && (
        <Button
          className='p0-sm bg-white'
          style={{ position: 'relative', top: '4px', right: '8px' }}
          onClick={downloadReportHandler}
          aria-label={new TranslatedCopy({ id: 'orderstatus.download.orderTrackingReport' }).toString()}
          title={new TranslatedCopy({ id: 'orderstatus.download.orderTrackingReport' }).toString()}
          data-desc='downloadReport__button'
        >
          <Data aria-hidden />
        </Button>
      )}
      <Button
        className='p0-sm bg-white'
        onClick={printHandler}
        aria-label={new TranslatedCopy({ id: 'orderreturns.report.print' }).toString()}
        data-desc='print__button'
      >
        <Icon name='print' alt={new TranslatedCopy({ id: 'orderreturns.report.print' }).toString()} />
      </Button>
    </div>
  </div>
);

OrderDetailsHeader.propTypes = {
  orderNumber: PropTypes.any,
  productCount: PropTypes.any,
  orderStatus: PropTypes.string,
  downloadHander: PropTypes.func.isRequired,
  downloadReportHandler: PropTypes.func.isRequired,
  printHandler: PropTypes.func.isRequired,
  showDownloadReportButton: PropTypes.bool
};

OrderDetailsHeader.defaultProps = {
  orderNumber: 0,
  productCount: 0,
  orderStatus: '',
  showDownloadReportButton: false
};

export default OrderDetailsHeader;
